import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import ListIcon from "@redotech/redo-icons/list.svg";
import { ExistsFilterOperator } from "@redotech/redo-views-common/advanced-filters/exists-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.pickSessionId;

export const PickSessionExistsFilter: AdvancedTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: true,
    operator: ExistsFilterOperator.NOT_EXISTS,
  },
  Icon: ListIcon,
  boolDisplay: { falseDisplay: "not assigned", trueDisplay: "assigned" },
  displayName: entry.displayName,
};
